export default __webpack_public_path__ + "static/media/square-4.205c410a.svg";